/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemandeInscriptionFichierDto
 */
export interface DemandeInscriptionFichierDto {
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierDto
     */
    iddemandeInscriptionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierDto
     */
    iddemandeInscription?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DemandeInscriptionFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DemandeInscriptionFichierDto interface.
 */
export function instanceOfDemandeInscriptionFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeInscriptionFichierDtoFromJSON(json: any): DemandeInscriptionFichierDto {
    return DemandeInscriptionFichierDtoFromJSONTyped(json, false);
}

export function DemandeInscriptionFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeInscriptionFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddemandeInscriptionFichier': !exists(json, 'iddemandeInscriptionFichier') ? undefined : json['iddemandeInscriptionFichier'],
        'iddemandeInscription': !exists(json, 'iddemandeInscription') ? undefined : json['iddemandeInscription'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DemandeInscriptionFichierDtoToJSON(value?: DemandeInscriptionFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddemandeInscriptionFichier': value.iddemandeInscriptionFichier,
        'iddemandeInscription': value.iddemandeInscription,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
    };
}

